import type { Setup } from "./useSetups";

const weakSigmaIndex = new WeakMap<Setup, Map<string /*string*/, number /*sigma*/>>();
const getQuantitySigma = (setup: Setup | null, quantityId: string) => {
  if (setup === null) return null;

  let index = weakSigmaIndex.get(setup);
  if (!index) {
    index = new Map(setup.diagnosisInputs.map(input => [input.quantityId, input.sigma]));
    weakSigmaIndex.set(setup, index);
  }

  return index.get(quantityId) ?? null;
};

export default getQuantitySigma;
